import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import FinalidadeOperacaoFiscalService from "./finalidadeOperacaoFiscalService"
import FormList from 'base/FormList'

export default function FinalidadeOperacaoFiscalList() {

    const [service] = useState(() => new FinalidadeOperacaoFiscalService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_fiof',
        dsName: 'descricao_fiof',
        mainField: { name: 'descricao_fiof', label: 'Descrição' },
        advFields: [
            { name: 'codigo_fiof', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_fiof', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_fiof" sortable header="Código"></Column>
            <Column field="descricao_fiof" sortable header="Descrição"></Column>
        </FormList >
    )
}
